import { useEffect } from "react";
import { oauthBroadcastChannel } from "#app/utils/broadcast-channels.client.js";

export default function Blank() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    oauthBroadcastChannel.postMessage(
      JSON.stringify({
        type: "authRedirect",
        ...Object.fromEntries(params.entries()),
      }),
    );
    // give the opener time to receive the message, then close this window
    setTimeout(() => {
      try {
        window.close();
      } catch {
        // ignore
      }
    }, 100);
  }, []);

  return (
    <h1 className="m-auto block h-screen w-full text-center">
      You can close this window now
    </h1>
  );
}
